export const JOB_TYPE_DIRECT = 'direct';
export const JOB_TYPE_PERFECT = 'perfect';